import pkg from 'steplix-emv-qrcps';
import { textLimit } from './utility';
const { Merchant } = pkg;

export default class BrCode {

  format_text(text) {
    return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim()
  }

  normalize(text) {
    if (text !== null)
      return this.format_text(text)
    else
      return text
  }

  formated_referance(reference) {
    return this.format_text(reference).replace(' ','');
  }

  formated_key(key, key_type) {
    var rkey = key;
    var ktype = key_type.toLowerCase();

    if (ktype === 'telefone' || ktype === 'cnpj' || ktype === "cpf")
      rkey = rkey.replace(/\D/g,'');

    if (ktype === "telefone")
      rkey = "+55" + rkey

    return rkey.trim()
  }

  generate_qrcp(key, amount, name, reference, key_type, city, cep) {

    key = this.normalize(key);
    name = textLimit(this.normalize(name), 25, '');
    reference = this.normalize(reference);
    key_type = this.normalize(key_type);
    city = textLimit(this.normalize(city), 15, '');

    var emvqr = Merchant.buildEMVQR();

    emvqr.setPayloadFormatIndicator("01");
    emvqr.setCountryCode("BR")
    emvqr.setMerchantCategoryCode("0000");
    emvqr.setTransactionCurrency("986");

    const merchantAccountInformation = Merchant.buildMerchantAccountInformation();
    merchantAccountInformation.setGloballyUniqueIdentifier("BR.GOV.BCB.PIX");

    let formatedKey = this.formated_key(key, key_type);
    merchantAccountInformation.addPaymentNetworkSpecific("01", formatedKey);

    emvqr.addMerchantAccountInformation("26", merchantAccountInformation);

    if (name)
      emvqr.setMerchantName(name);

    if (city)
      emvqr.setMerchantCity(city);

    if (amount && amount !== '')
      emvqr.setTransactionAmount(amount);

    const additionalDataFieldTemplate = Merchant.buildAdditionalDataFieldTemplate();

    if (reference && reference !== '') {
      reference = this.formated_referance(reference);
      additionalDataFieldTemplate.setReferenceLabel(reference);
    }
    else
      additionalDataFieldTemplate.setReferenceLabel("***");

    emvqr.setAdditionalDataFieldTemplate(additionalDataFieldTemplate);
    return emvqr.generatePayload();
  }
}